/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftSwap } from './ShiftSwap';
import {
    ShiftSwapFromJSON,
    ShiftSwapFromJSONTyped,
    ShiftSwapToJSON,
    ShiftSwapToJSONTyped,
} from './ShiftSwap';

/**
 * 
 * @export
 * @interface ApproveShiftSwapResponse
 */
export interface ApproveShiftSwapResponse {
    /**
     * 
     * @type {ShiftSwap}
     * @memberof ApproveShiftSwapResponse
     */
    data: ShiftSwap;
}

/**
 * Check if a given object implements the ApproveShiftSwapResponse interface.
 */
export function instanceOfApproveShiftSwapResponse(value: object): value is ApproveShiftSwapResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ApproveShiftSwapResponseFromJSON(json: any): ApproveShiftSwapResponse {
    return ApproveShiftSwapResponseFromJSONTyped(json, false);
}

export function ApproveShiftSwapResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveShiftSwapResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ShiftSwapFromJSON(json['data']),
    };
}

  export function ApproveShiftSwapResponseToJSON(json: any): ApproveShiftSwapResponse {
      return ApproveShiftSwapResponseToJSONTyped(json, false);
  }

  export function ApproveShiftSwapResponseToJSONTyped(value?: ApproveShiftSwapResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ShiftSwapToJSON(value['data']),
    };
}

